import React from 'react';
import PortalModal from '../../../common/PortalModal/PortalModal';

export default function PolicyDetailsModal({ policy, onClose }) {
  if (!policy) return null;

  return (
    <PortalModal
      isOpen
      onClose={onClose}
      title={
        <>
          <i className="fas fa-shield-alt"></i>
          Policy Details
        </>
      }
      size="medium"
      bodyClassName="rbac-modal-body"
    >
      <div className="modal-body">
          {/* Policy Name */}
          <div className="form-group">
            <label>Policy Name</label>
            <div style={{ 
              padding: '0.75rem', 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderRadius: '8px',
              fontWeight: '600',
              color: '#fff'
            }}>
              {policy.policy_name}
            </div>
          </div>

          {/* Description */}
          <div className="form-group">
            <label>Description</label>
            <div style={{ 
              padding: '0.75rem', 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderRadius: '8px',
              lineHeight: '1.5',
              color: 'rgba(255, 255, 255, 0.9)'
            }}>
              {policy.description}
            </div>
          </div>

          {/* Permissions */}
          <div className="form-group">
            <label>Permissions ({policy.permissions?.length || 0})</label>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '0.75rem' 
            }}>
              {policy.permissions && policy.permissions.length > 0 ? (
                policy.permissions.map((perm, idx) => (
                  <div 
                    key={idx} 
                    style={{ 
                      padding: '1rem', 
                      background: 'rgba(255, 255, 255, 0.05)', 
                      borderRadius: '8px',
                      border: '1px solid rgba(255, 255, 255, 0.1)'
                    }}
                  >
                    <div style={{ marginBottom: '0.75rem' }}>
                      <strong style={{ color: '#64b5f6', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Resource</strong>
                      <div style={{ 
                        marginTop: '0.5rem',
                        padding: '0.5rem 0.75rem', 
                        background: 'rgba(100, 181, 246, 0.1)', 
                        borderRadius: '6px',
                        color: '#fff',
                        fontWeight: '500'
                      }}>
                        {perm.resource}
                      </div>
                    </div>
                    <div>
                      <strong style={{ color: '#64b5f6', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Actions</strong>
                      <div style={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: '0.5rem', 
                        marginTop: '0.5rem' 
                      }}>
                        {Array.isArray(perm.actions) ? perm.actions.map((action, actionIdx) => (
                          <span 
                            key={actionIdx} 
                            style={{ 
                              padding: '0.25rem 0.75rem', 
                              background: 'rgba(255, 255, 255, 0.1)', 
                              borderRadius: '12px',
                              fontSize: '0.85rem',
                              color: 'rgba(255, 255, 255, 0.9)',
                              fontWeight: '500'
                            }}
                          >
                            {action}
                          </span>
                        )) : (
                          <span style={{ 
                            padding: '0.25rem 0.75rem', 
                            background: 'rgba(255, 255, 255, 0.1)', 
                            borderRadius: '12px',
                            fontSize: '0.85rem',
                            color: 'rgba(255, 255, 255, 0.9)',
                            fontWeight: '500'
                          }}>
                            {perm.actions}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ 
                  padding: '1rem', 
                  background: 'rgba(255, 255, 255, 0.05)', 
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}>
                  No permissions defined
                </div>
              )}
            </div>
          </div>
        </div>
    </PortalModal>
  );
}
